// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1MJt1","item":"PaymentsMobile_item__2K0Jb","label":"PaymentsMobile_label__3omyF","amount":"PaymentsMobile_amount__M4S8r"};